import { render, staticRenderFns } from "./PassSafeguardContract.vue?vue&type=template&id=c527cf32&"
import script from "./PassSafeguardContract.vue?vue&type=script&lang=js&"
export * from "./PassSafeguardContract.vue?vue&type=script&lang=js&"
import style0 from "./PassSafeguardContract.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports